import * as React from "react";
import { Stack } from "@chakra-ui/react";

import useRouter from "hooks/useRouter";
import Button from "components/Chakra/Button";
import { useDetailState } from "scenes/OfferDetail";

const EditOwn: React.FC = () => {
  const { navigateTo } = useRouter();
  const { status, id } = useDetailState();

  return (
    <Stack pb={2}>
      <Button
        onClick={() => {
          navigateTo("/uprava-inzeratu/kontakt/[status]/[id]/[paidId]", {
            status,
            id: id?.toString(),
          });
        }}
        data-test="offerDetail.editButton"
      >
        Editovat
      </Button>
    </Stack>
  );
};

export default EditOwn;
